<template>
  <div class="apply_box">
    <div class="header"
         v-for="(item,index) in orderList"
         :key="'h'+index">
      <div class="loanMoney">{{item.title}}</div>
      <p class="title">{{item.rightTitle}}</p>
    </div>
    <div class="bg"></div>
    <div class="pro_detail"
         v-for="(item,index) in allList"
         :key="'p'+index">
      <div class="pro_item">
        <h1 class="h1"><span class="line"></span> {{item.head.title}}</h1><span class="look"
              @click="toPage(item.head.pageUrl)">{{item.head.rightTitle}}</span>
      </div>
      <div class="pro_item"
           v-for="(itm,idx) in item.content"
           :key="'i'+idx">
        <p>{{itm.title}}</p>
        <p>{{itm.rightTitle}}</p>
      </div>
    </div>
    <div class="bg"></div>
    <div class="pro_detail"
         v-for="(item,index) in cardList"
         :key="'pd'+index">
      <div class="pro_item">
        <h1 class="h1"><span class="line"></span> {{cardJson.title}}</h1>
      </div>
      <!-- 已绑卡 -->
      <div class="card_box"
           v-if="item.isBind>0">
        <div class="pro_item1">
          <img class="bank_icon left"
               :src="item.cardUrl"
               alt="">
          <p class="bank_name left">{{item.cardName}}</p>
          <span class="card_num left">{{item.cardNumber}}</span>
          <!-- <span class="replace_btn right">更换</span> -->
        </div>
        <div class="info_box">
          {{item.note}}
          <div class="xy_box">
            <span class="icon_circle"
                  :class="{'icon_circleAct':isActive}"
                  @click="checkStatus()"></span>
            {{footJson.describe}}
            <span class="agree"
                  v-for="(itm,idx) in footList"
                  :key="'c'+idx"
                  @click="toPage(itm.pageUrl)">{{itm.title}}<span v-show="footList.length-1 != idx">、</span></span>
          </div>
        </div>
      </div>
      <!-- 未绑卡 -->
      <div class="card_box"
           v-else>
        <div class="pro_item">
          <p class="btn"
             @click="toPage(item.pageUrl)"><span class="bank_btn"></span>添加</p>
        </div>
        <div class="info_box">
          <div class="xy_box">
            <span class="icon_circle"
                  :class="{'icon_circleAct':isActive}"
                  @click="checkStatus()"></span>
            {{footJson.describe}}
            <span class="agree"
                  v-for="(itm,idx) in footList"
                  :key="'c'+idx"
                  @click="toPage(itm.pageUrl)">{{itm.title}}<span v-show="footList.length-1 != idx">、</span></span>
          </div>
        </div>
      </div>
      <!-- <div class="info_box">
        <span class="icon_circle"
              :class="{'icon_circleAct':isActive}"
              @click="checkStatus()"></span>
        {{footJson.describe}}
        <span class="agree"
              v-for="(itm,idx) in footList"
              :key="'c'+idx"
              @click="toPage(itm)">{{itm.title}}<span v-show="footList.length-1 != idx">、</span></span>
      </div> -->
    </div>
    <div class="btn_box"
         v-for="(item,index) in buttonList"
         :key="'b'+index">
      <div class="loan_btn"
           @click="toPage(item.pageUrl)">{{item.title}}</div>
    </div>

  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      allList: [],
      orderId: '',
      orderList: [],
      bigList: [],
      bigJson: {},
      cardList: [],
      cardJson: {},
      buttonList: [],
      footList: [],
      footJson: [],
      isActive: true,
    }
  },
  mounted () {
    this.orderId = this.$route.query.orderId;
    this.util.title('签约');
    this.getDetails()
  },
  methods: {
    getDetails () {
      let param = {
        orderId: this.orderId
      }
      let _this = this;
      this.$get('/app/api/v1/signing/view', param)
        .then(res => {
          var e = res;
          if (e.code == 200) {
            e.data.appOrderCells.map(function (item) {
              if (item.type == "signingTop") {
                _this.orderList = item.content//借款金额
              } else if (item.type == "bigList") {
                _this.allList.push(item);
              } else if (item.type == "card") {
                _this.cardList = item.content;
                _this.cardJson = item.head;
                _this.footJson = item.foot;
                _this.footList = item.foot.footClick;
              } else if (item.type == "button") {
                _this.buttonList = item.content;
              }
            })
          }
          else {
            _this.util.toast({ msg: e.msg })
          }
        })
        .catch(error => { });
    },
    //去分期
    toPage (pageUrl) {
      if (pageUrl == '') {
        this.util.toast({ msg: '请先完成绑卡，若已绑卡请2分钟后再签约' })
      } else {
        window.location.href = pageUrl;
      }
    },
    checkStatus () {
      this.isActive = !this.isActive;
    }
  }
}
</script>
<style scoped>
.apply_box {
  background: #f7f7f7;
  padding-bottom: 0.2rem;
}
.bg {
  background: #f7f7f7;
  width: 100%;
  height: 0.1rem;
}
.header {
  padding: 0.3rem 0 0.3rem 0;
  /* margin-bottom: 0.1rem; */
  background: #ffffff;
}
.loanMoney {
  color: #999;
  font-size: 0.14rem;
  text-align: center;
}
.pro_detail {
  background: #ffffff;
  margin-bottom: 0.1rem;
}
.title {
  color: #333;
  font-size: 0.3rem;
  text-align: center;
}
.pro_item {
  padding: 0.15rem;
  border-bottom: 1px solid #eee;
  display: flex;
  flex: 1;
  justify-content: space-between;
}
.pro_item .btn {
  color: #486cff;
  font-size: 0.14rem;
  text-align: center;
  margin: 0 auto;
  padding: 0.1rem;
}
.h1 {
  font-size: 0.16rem;
  color: #333;
}
.line {
  display: inline-block;
  width: 3px;
  height: 0.12rem;
  background: #486cff;
}
.info_box {
  font-size: 0.11rem;
  color: #333;
  padding: 0.1rem 0.15rem 0.36rem 0.15rem;
  background: #f7f7f7;
}
.info_box .agree {
  color: #486cff;
}
.icon_circle,
.icon_circleAct {
  position: relative;
  top: 0.02rem;
  margin-right: 0.05rem;
  display: inline-block;
  width: 0.14rem;
  height: 0.14rem;
  background: url("../../assets/img/afterLoan/choice_unCheck.png") no-repeat top
    center;
  background-size: 100% 100%;
}
.icon_circleAct {
  background: url("../../assets/img/afterLoan/checked.png") no-repeat top center;
  background-size: 100% 100%;
}
.bank_btn {
  display: inline-block;
  width: 0.14rem;
  height: 0.14rem;
  background: url("../../assets/img/afterLoan/add_btn.png") no-repeat top center;
  background-size: 100% 100%;
  margin: 0 auto;
  text-align: center;
  margin-right: 0.1rem;
  position: relative;
  top: 0.02rem;
}
.loan_btn {
  color: #fff;
  background: linear-gradient(
    90deg,
    rgba(122, 157, 246, 1) 0%,
    rgba(81, 117, 241, 1) 100%
  );
  box-shadow: 0px 6px 10px 0px rgba(228, 238, 250, 1);
  border-radius: 25px;
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.17rem;
  text-align: center;
  line-height: 0.5rem;
  width: 90%;
  margin: 0 auto;
}
.look {
  color: #486cff;
  font-size: 0.13rem;
  float: right;
}
.btn_box {
  margin-top: 0.3rem;
}
.pro_item1 {
  padding: 0.15rem;
  clear: both;
  overflow: hidden;
}
.xy_box {
  margin-top: 0.1rem;
}
</style>